import React from 'react';
import logo from './logo.svg';
import { Html5Qrcode } from 'html5-qrcode'
import {CloseOutline} from "antd-mobile-icons";

function Qrcode(props:any) {
  const {current:tempObj} = React.useRef<any>({camera:false,runing:false});

  React.useEffect(()=>{
    if(!tempObj.camera) getCameras();
    if(props.active && tempObj.camera && !tempObj.runing) {
      tempObj.html5QrCode = new Html5Qrcode('reader')
      start();
    }
    return ()=>{
      if(tempObj.camera && tempObj.runing) {
        tempObj.runing = false
        tempObj.html5QrCode.stop().then((ignore:any) => {
          // QR Code scanning is stopped.
          console.log("QR Code scanning stopped.")
        })
          .catch((err:any) => {
            // Stop failed, handle it.
            console.log("Unable to stop scanning.")
          })
      }
    }
  },[props.active]);
  const getCameras = () => {
    Html5Qrcode.getCameras()
      .then((devices: string | any[]) => {
        if (devices && devices.length) {
          //tempObj.isShow.value = true
          // start开始扫描
          tempObj.camera = true
          if(props.active && !tempObj.runing) {
            tempObj.html5QrCode = new Html5Qrcode('reader')
            start();
          }
        }
      })
      .catch((err: string) => {
        // handle err
        console.log('获取设备信息失败', err) // 获取设备信息失败
        alert('获取设备信息失败'+err)
      })
  }

  const start = () => {
    tempObj.runing = true;
    tempObj.html5QrCode
      .start(
        {facingMode: "environment" },
        {
          fps: 20, // 设置每秒多少帧
          qrbox: { width: 250, height: 250 } // 设置取景范围
          // scannable, rest shaded.
        },
        (decodedText: any, decodedResult: any) => {
          //alert('扫码结果' + decodedText)
          props.onCode(decodedText);
          props.onClose();
        },
        (errorMessage: any) => {
          // parse error, ideally ignore it. For example:
          // console.log(`QR Code no longer in front of camera.`);
          //console.log('暂无额扫描结果', errorMessage)
        }
      )
      .catch((err: any) => {
        // Start failed, handle it. For example,
        console.log(`Unable to start scanning, error: ${err}`)
      })
  }


  return (
    <div style={{background: 'rgb(0,0,0,0.3)',position: 'absolute',top:0,left:0,right:0,bottom:0 ,display:(props.active?'flex':'none'),alignItems:'center',justifyContent:'center',zIndex:999}}>
      <div style={{position: 'absolute',top:20,right:20,fontSize:25,color:'#fff'}}>
        <CloseOutline onClick={()=>props.onClose()}/>
      </div>
      <div id ="reader" {...props} style={{width:'100%'}}>
        loadCam
      </div>
    </div>
  );
}
export default Qrcode;

